import {Title} from '@app/titles/models/title';
import {TitleRating} from '@app/reviews/title-rating';
import {getTitleLink, TitleLink} from '@app/titles/title-link';
import {ReactNode, useMemo} from 'react';
import {TitleBackdrop} from '@app/titles/title-poster/title-backdrop';
import {FormattedDate} from '@common/i18n/formatted-date';
import {useNavigate} from 'react-router-dom';
import {NoImagePoster} from '../../../../public/assets/svg';
import {useImageSrc} from '@app/images/use-image-src';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import {useSelectedLocale} from '@common/i18n/selected-locale';

export interface TitlePortraitGridItemProps {
  item: Title;
  rating?: number;
  description?: ReactNode;
  noLazy?: boolean
}
export function TitlePortraitGridItem({
  item,
  rating,
  description,
  noLazy
}: TitlePortraitGridItemProps) {
  const link = useMemo(() => {
    return getTitleLink(item);
  }, [item]);
  const {locale} = useSelectedLocale();

  const navigate = useNavigate();

  const isTvDevice = () => {
    //@ts-expect-error
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    const tvKeywords = ['SmartTV', 'Tizen', 'DTV', 'WebOS', 'LGTV', 'Samsung'];
    return tvKeywords.some(keyword => userAgent.includes(keyword));
  };

  const src = useImageSrc(item.poster);

  return (
    <div
      onClick={() => navigate(link)}
      className="iq-card card-hover cursor-pointer"
    >
      <div className={`relative w-100 ${isTvDevice() ? '' : 'block-images'}`}>
        <div className={`relative w-100 ${isTvDevice() ? '' : 'img-box'}`}>
          {noLazy ? (
            <img
              className={`img-fluid d-block position-relative !z-[100] w-100 border-0 object-cover`}
              src={src || NoImagePoster.default}
              alt="movie-card"
            />
          ) : (
            <LazyLoadImage
              src={src || NoImagePoster.default}
              alt="movie-card"
              // decoding="async"
              className={`img-fluid d-block position-relative !z-[100] w-100 border-0 object-cover`}
              effect="blur"
            />
          )}
        </div>
        <div className="card-description with-transition">
          <div className="cart-content">
            <div className="content-left">
              <h5 className="iq-title text-capitalize ">
                <span className="block overflow-y-clip text-base font-medium">
                  {locale.language === 'fa' && item.persian_name
                    ? item.persian_name
                    : item.name}
                </span>
                {/* <TitleLink

                  title={item}
                  className="block overflow-y-clip text-base font-medium"
                /> */}
              </h5>
              <div className="movie-time d-flex align-items-center my-2">
                <span className="movie-time-text font-normal">
                  {item.runtime}
                </span>
              </div>
            </div>
            <RatingOrReleaseDate
              title={item}
              rating={rating}
              className="mb-4"
            />
            {description ? <div className="mt-4">{description}</div> : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export function TitleLandscapeGridItem({item}: TitlePortraitGridItemProps) {
  return (
    <div className="flex w-full flex-col">
      <TitleBackdrop
        title={item}
        srcSize="lg"
        size="w-full"
        className="rounded"
        wrapWithLink
        showPlayButton
      />
      <div className="mt-10 flex w-full items-center justify-between">
        <TitleLink title={item} className=" whitespace-nowrap " />
        {/* <BulletSeparatedItems className="mb-4">
          {item.release_date && <FormattedDate date={item.release_date} />}
          {item.certification && (
            <div className="uppercase">{item.certification}</div>
          )}
        </BulletSeparatedItems> */}
        <TitleRating score={item.rating} />
      </div>
      {item.release_date && <FormattedDate date={item.release_date} />}
    </div>
  );
}

interface RatingOrReleaseDateProps {
  title: Title;
  rating?: number;
  className?: string;
}
function RatingOrReleaseDate({
  title,
  rating,
  className,
}: RatingOrReleaseDateProps) {
  if (!rating) {
    rating = title.rating;
  }
  if (rating) {
    return <TitleRating score={rating} className={className} />;
  }
  if (title.release_date) {
    return (
      <div className={className}>
        <FormattedDate date={title.release_date} />
      </div>
    );
  }
  return null;
}
